export const BODY_DREAMS = {
  id: 'body',
  name: '신체 꿈',
  emoji: '🦷',
  color: '#ff6b6b',
  description: '이빨, 머리카락, 피, 눈 등 신체가 나오는 꿈 해몽',
  seoTitle: '신체 꿈해몽 - 신체부위별 꿈 해석 총정리',
  seoDescription: '이빨 빠지는 꿈, 머리카락 빠지는 꿈, 피가 나는 꿈 등 신체 꿈의 의미를 알아보세요.',
  subjects: [
    {
      id: 'teeth',
      name: '이빨 꿈',
      emoji: '🦷',
      summary: '이빨꿈은 건강, 자신감, 변화를 상징합니다.',
      seoTitle: '이빨꿈 해몽 - 이빨 나오는 꿈 해석',
      seoDescription: '이빨 빠지는 꿈, 이빨이 부러지는 꿈, 이빨이 흔들리는 꿈 등의 해몽을 확인하세요.',
      scenarios: [
        { id: 'teeth-fall', title: '이빨이 빠지는 꿈', interpretation: '이빨이 빠지는 꿈은 가장 흔한 꿈 중 하나로, 가족이나 가까운 사람에 대한 걱정을 나타냅니다. 건강에 주의하고, 가족에게 안부를 물어보세요. 재물 손실을 의미하기도 합니다.', omen: 'caution', luckyNumbers: [4, 11, 20, 29, 34, 40], tags: ['건강', '가족'] },
        { id: 'teeth-break', title: '이빨이 부러지는 꿈', interpretation: '이빨이 부러지는 꿈은 자신감에 상처를 입을 수 있는 일이 생길 수 있음을 경고합니다. 자존감을 잘 지키고, 부정적인 말에 흔들리지 마세요.', omen: 'caution', luckyNumbers: [3, 10, 19, 28, 37, 42], tags: ['자존감', '주의'] },
        { id: 'teeth-loose', title: '이빨이 흔들리는 꿈', interpretation: '이빨이 흔들리는 꿈은 현재 상황이 불안정하다는 것을 반영합니다. 기반을 튼튼히 하고, 중요한 결정은 신중하게 하세요.', omen: 'caution', luckyNumbers: [5, 13, 22, 31, 38, 43], tags: ['불안정', '신중'] },
        { id: 'new-teeth', title: '새 이빨이 나는 꿈', interpretation: '새 이빨이 나는 꿈은 새로운 시작과 성장을 의미하는 길몽입니다. 자신감이 회복되고, 새로운 능력이 생길 수 있습니다.', omen: 'good', luckyNumbers: [1, 9, 18, 27, 36, 45], tags: ['성장', '자신감'] },
        { id: 'white-teeth', title: '하얗고 건강한 이빨 꿈', interpretation: '하얗고 건강한 이빨을 보는 꿈은 건강운과 자신감이 상승하는 길몽입니다. 외모에 대한 자신감도 높아질 것입니다.', omen: 'good', luckyNumbers: [2, 8, 17, 26, 35, 44], tags: ['건강', '자신감'] },
        { id: 'gold-teeth', title: '금니가 보이는 꿈', interpretation: '금니가 보이는 꿈은 재물운이 상승할 것을 의미합니다. 특히 사업이나 투자에서 좋은 결과를 얻을 수 있습니다.', omen: 'good', luckyNumbers: [7, 14, 23, 32, 38, 43], tags: ['재물운', '투자'] },
      ]
    },
    {
      id: 'hair',
      name: '머리카락 꿈',
      emoji: '💇',
      summary: '머리카락꿈은 생각, 에너지, 매력을 상징합니다.',
      seoTitle: '머리카락꿈 해몽 - 머리카락 나오는 꿈 해석',
      seoDescription: '머리카락 빠지는 꿈, 머리를 자르는 꿈, 긴 머리 꿈 등의 해몽을 확인하세요.',
      scenarios: [
        { id: 'hair-loss', title: '머리카락이 빠지는 꿈', interpretation: '머리카락이 빠지는 꿈은 걱정이나 스트레스가 많다는 것을 반영합니다. 충분히 쉬고, 스트레스 관리에 신경 쓰세요. 건강 검진도 고려해보세요.', omen: 'caution', luckyNumbers: [4, 11, 20, 29, 37, 42], tags: ['스트레스', '건강'] },
        { id: 'hair-cut', title: '머리를 자르는 꿈', interpretation: '머리를 자르는 꿈은 과거와의 단절이나 새로운 시작을 의미합니다. 머리를 잘 잘랐다면 좋은 변화가, 못 잘랐다면 후회할 선택을 경고합니다.', omen: 'good', luckyNumbers: [1, 9, 18, 27, 36, 44], tags: ['새시작', '변화'] },
        { id: 'long-hair', title: '머리카락이 길어지는 꿈', interpretation: '머리카락이 길어지는 꿈은 매력이 높아지고 인기가 상승할 것을 의미합니다. 대인관계에서 좋은 인상을 줄 수 있습니다.', omen: 'good', luckyNumbers: [3, 10, 19, 28, 35, 43], tags: ['매력', '인기'] },
        { id: 'white-hair', title: '흰 머리카락이 나는 꿈', interpretation: '흰 머리카락이 나는 꿈은 지혜와 성숙함을 상징합니다. 경험에서 우러나오는 지혜가 빛을 발할 시기입니다.', omen: 'good', luckyNumbers: [5, 14, 23, 32, 39, 45], tags: ['지혜', '성숙'] },
        { id: 'beautiful-hair', title: '윤기 나는 머리카락 꿈', interpretation: '윤기 나고 아름다운 머리카락 꿈은 건강과 활력이 넘치는 시기를 의미합니다. 외모적 매력뿐 아니라 내면적 에너지도 충만해질 것입니다.', omen: 'good', luckyNumbers: [2, 8, 17, 26, 36, 42], tags: ['건강', '활력'] },
      ]
    },
    {
      id: 'blood',
      name: '피 꿈',
      emoji: '🩸',
      summary: '피꿈은 생명력, 에너지, 재물을 상징합니다.',
      seoTitle: '피꿈 해몽 - 피 나오는 꿈 해석',
      seoDescription: '피가 나는 꿈, 코피 꿈, 피를 보는 꿈 등의 해몽을 확인하세요.',
      scenarios: [
        { id: 'bleeding', title: '피가 나는 꿈', interpretation: '피가 나는 꿈은 역설적으로 재물이 들어올 길몽입니다. 특히 많은 피가 났다면 큰 재물운을 의미합니다. 에너지가 빠져나가는 것이 아니라 새로운 에너지가 들어온다는 의미입니다.', omen: 'good', luckyNumbers: [1, 9, 18, 27, 36, 45], tags: ['재물운', '에너지'] },
        { id: 'nosebleed', title: '코피가 나는 꿈', interpretation: '코피가 나는 꿈은 건강에 주의하라는 신호이면서, 동시에 뜻밖의 재물을 의미하기도 합니다. 건강 관리와 함께 금전 운도 체크하세요.', omen: 'caution', luckyNumbers: [3, 10, 19, 28, 37, 43], tags: ['건강', '재물운'] },
        { id: 'blood-stain', title: '피 묻은 옷을 보는 꿈', interpretation: '피 묻은 옷을 보는 꿈은 과거의 상처나 문제가 아직 해결되지 않았음을 의미합니다. 과거를 정리하면 마음이 편안해질 것입니다.', omen: 'caution', luckyNumbers: [4, 12, 21, 30, 38, 41], tags: ['정리', '치유'] },
        { id: 'blood-river', title: '피가 강처럼 흐르는 꿈', interpretation: '피가 강처럼 흐르는 꿈은 큰 재물이 들어올 대길몽입니다. 사업이나 투자에서 큰 수익을 기대할 수 있습니다.', omen: 'good', luckyNumbers: [7, 14, 23, 32, 38, 44], tags: ['대길', '재물운'] },
      ]
    },
    {
      id: 'eye',
      name: '눈(눈동자) 꿈',
      emoji: '👁️',
      summary: '눈꿈은 통찰력, 인식, 진실을 상징합니다.',
      seoTitle: '눈꿈 해몽 - 눈(눈동자) 나오는 꿈 해석',
      seoDescription: '눈이 밝아지는 꿈, 눈이 안 보이는 꿈 등의 해몽을 확인하세요.',
      scenarios: [
        { id: 'bright-eyes', title: '눈이 밝아지는 꿈', interpretation: '눈이 밝아지는 꿈은 통찰력이 높아지고 진실을 볼 수 있게 되는 것을 의미합니다. 중요한 판단을 내릴 때 신뢰할 수 있는 직감이 생깁니다.', omen: 'good', luckyNumbers: [1, 9, 18, 27, 36, 45], tags: ['통찰', '지혜'] },
        { id: 'blind', title: '눈이 안 보이는 꿈', interpretation: '눈이 안 보이는 꿈은 현실에서 무언가를 간과하고 있다는 경고입니다. 주변 상황을 더 세심하게 살피세요.', omen: 'caution', luckyNumbers: [4, 11, 20, 29, 34, 40], tags: ['경고', '주의'] },
        { id: 'big-eyes', title: '큰 눈을 가지는 꿈', interpretation: '큰 눈을 가지는 꿈은 세상을 더 넓게 보게 될 것을 의미합니다. 새로운 관점을 얻거나 시야가 넓어지는 경험을 하게 됩니다.', omen: 'good', luckyNumbers: [3, 10, 19, 28, 37, 43], tags: ['시야', '관점'] },
        { id: 'third-eye', title: '제3의 눈이 열리는 꿈', interpretation: '제3의 눈이 열리는 꿈은 영적 각성이나 특별한 직감을 얻게 될 것을 의미합니다. 초자연적인 통찰력이 높아질 수 있습니다.', omen: 'good', luckyNumbers: [7, 14, 23, 32, 39, 44], tags: ['각성', '직감'] },
      ]
    },
    {
      id: 'hand',
      name: '손 꿈',
      emoji: '🤲',
      summary: '손꿈은 능력, 관계, 행동을 상징합니다.',
      seoTitle: '손꿈 해몽 - 손 나오는 꿈 해석',
      seoDescription: '손을 잡는 꿈, 손이 커지는 꿈, 손가락 꿈 등의 해몽을 확인하세요.',
      scenarios: [
        { id: 'hold-hands', title: '손을 잡는 꿈', interpretation: '누군가의 손을 잡는 꿈은 새로운 인연이나 협력 관계가 시작될 것을 의미합니다. 좋은 파트너를 만날 수 있습니다.', omen: 'good', luckyNumbers: [2, 10, 19, 28, 37, 44], tags: ['인연', '협력'] },
        { id: 'big-hands', title: '손이 커지는 꿈', interpretation: '손이 커지는 꿈은 능력이 확장되고 영향력이 커질 것을 의미합니다. 더 큰 일을 맡게 되거나 권한이 넓어질 수 있습니다.', omen: 'good', luckyNumbers: [1, 8, 17, 26, 35, 43], tags: ['능력', '확장'] },
        { id: 'hand-injury', title: '손을 다치는 꿈', interpretation: '손을 다치는 꿈은 일을 진행하는 데 장애가 생길 수 있다는 경고입니다. 중요한 일을 할 때 더 조심하세요.', omen: 'caution', luckyNumbers: [4, 12, 21, 30, 38, 41], tags: ['주의', '장애'] },
        { id: 'wash-hands', title: '손을 씻는 꿈', interpretation: '손을 씻는 꿈은 과거의 잘못이나 부담에서 벗어나게 될 것을 의미합니다. 깨끗한 마음으로 새 출발을 할 수 있습니다.', omen: 'good', luckyNumbers: [3, 9, 18, 27, 36, 42], tags: ['정화', '새출발'] },
      ]
    },
    {
      id: 'pregnancy',
      name: '임신 꿈',
      emoji: '🤰',
      summary: '임신꿈은 창조, 새 프로젝트, 성장을 상징합니다.',
      seoTitle: '임신꿈 해몽 - 임신하는 꿈 해석',
      seoDescription: '임신하는 꿈, 배가 부른 꿈, 출산 꿈 등의 해몽을 확인하세요.',
      scenarios: [
        { id: 'pregnant', title: '임신하는 꿈', interpretation: '임신하는 꿈은 새로운 아이디어나 프로젝트가 성장하고 있음을 의미합니다. 실제 태몽일 수도 있으며, 창조적인 결과물이 나올 수 있습니다.', omen: 'good', luckyNumbers: [1, 9, 18, 27, 36, 45], tags: ['창조', '성장'] },
        { id: 'big-belly', title: '배가 불러오는 꿈', interpretation: '배가 불러오는 꿈은 기대하는 것이 점점 현실에 가까워지고 있음을 의미합니다. 인내심을 가지고 기다리세요.', omen: 'good', luckyNumbers: [3, 10, 19, 28, 37, 43], tags: ['기대', '실현'] },
        { id: 'give-birth', title: '출산하는 꿈', interpretation: '출산하는 꿈은 큰 성과나 결과물이 탄생할 것을 의미합니다. 오랫동안 준비한 일이 드디어 결실을 맺습니다.', omen: 'good', luckyNumbers: [7, 14, 23, 32, 38, 44], tags: ['탄생', '결실'] },
        { id: 'others-pregnant', title: '다른 사람이 임신한 꿈', interpretation: '다른 사람이 임신한 꿈은 주변에서 좋은 소식이 전해질 것을 의미합니다. 축하할 일이 생기거나 간접적으로 행운을 얻을 수 있습니다.', omen: 'good', luckyNumbers: [2, 10, 19, 28, 37, 42], tags: ['기쁨', '소식'] },
      ]
    },
    {
      id: 'naked',
      name: '벗은 몸 꿈',
      emoji: '😳',
      summary: '벗은 몸 꿈은 취약함, 진솔함, 자기 노출을 상징합니다.',
      seoTitle: '알몸꿈 해몽 - 벗은 몸 꿈 해석',
      seoDescription: '알몸으로 돌아다니는 꿈, 옷을 벗는 꿈 등의 해몽을 확인하세요.',
      scenarios: [
        { id: 'naked-public', title: '사람들 앞에서 벗은 꿈', interpretation: '사람들 앞에서 벗은 꿈은 비밀이 드러나거나 취약한 모습이 노출될 수 있다는 경고입니다. 개인 정보 관리에 주의하세요.', omen: 'caution', luckyNumbers: [4, 11, 20, 29, 34, 41], tags: ['비밀', '주의'] },
        { id: 'naked-comfortable', title: '벗은 채로 편안한 꿈', interpretation: '벗은 채로 편안한 꿈은 자신을 있는 그대로 받아들이고 있다는 의미입니다. 자기 긍정감이 높아지고 당당해질 수 있습니다.', omen: 'good', luckyNumbers: [1, 9, 18, 27, 36, 45], tags: ['자기수용', '당당'] },
        { id: 'undress', title: '옷을 벗는 꿈', interpretation: '옷을 벗는 꿈은 가식이나 껍데기를 벗고 진실된 모습을 보이게 될 것을 의미합니다. 솔직함이 오히려 좋은 결과를 가져옵니다.', omen: 'good', luckyNumbers: [3, 10, 19, 28, 37, 43], tags: ['진솔', '솔직'] },
      ]
    },
    {
      id: 'foot',
      name: '발 꿈',
      emoji: '🦶',
      summary: '발꿈은 인생의 기반, 전진, 안정감을 상징합니다.',
      seoTitle: '발꿈 해몽 - 발 나오는 꿈 해석',
      seoDescription: '발을 다치는 꿈, 맨발로 걷는 꿈, 발이 커지는 꿈 등 발꿈의 해몽을 확인하세요.',
      scenarios: [
        { id: 'barefoot', title: '맨발로 걷는 꿈', interpretation: '맨발로 걷는 꿈은 기본으로 돌아가야 할 시기임을 의미합니다. 허울과 겉치레를 벗고 진정한 자신의 모습으로 살아가면, 오히려 더 큰 자유와 편안함을 얻을 수 있습니다. 땅의 기운을 직접 느끼는 것처럼 현실과 밀착된 삶을 살아보세요.', omen: 'caution', luckyNumbers: [1, 9, 18, 27, 36, 44], tags: ['본질', '자유'] },
        { id: 'foot-injury', title: '발을 다치는 꿈', interpretation: '발을 다치는 꿈은 전진하는 데 장애가 생길 수 있다는 경고입니다. 계획하던 일에 차질이 생기거나, 여행이나 이동에 문제가 생길 수 있으니 일정을 꼼꼼히 확인하세요. 기반을 다지는 데 더 신경 써야 할 때입니다.', omen: 'caution', luckyNumbers: [4, 12, 21, 30, 38, 41], tags: ['장애', '주의'] },
        { id: 'big-foot', title: '발이 커지는 꿈', interpretation: '발이 커지는 꿈은 인생의 기반이 넓어지고 안정감이 높아질 것을 의미합니다. 재산이 늘어나거나 사회적 입지가 튼튼해지며, 여러 방면에서 활동 범위가 넓어질 수 있습니다. 자신감을 가지고 더 큰 무대로 나아가세요.', omen: 'good', luckyNumbers: [3, 10, 19, 28, 37, 45], tags: ['안정', '확장'] },
        { id: 'wash-feet', title: '발을 씻는 꿈', interpretation: '발을 씻는 꿈은 지금까지의 고생과 피로를 씻어내고 새로운 활력을 얻게 될 것을 의미합니다. 과거의 실수나 부정적인 경험을 정리하고, 깨끗한 마음으로 새 출발할 수 있는 시기입니다.', omen: 'good', luckyNumbers: [5, 14, 23, 32, 39, 43], tags: ['정화', '새출발'] },
        { id: 'foot-massage', title: '발 마사지를 받는 꿈', interpretation: '발 마사지를 받는 꿈은 그동안의 수고에 대한 보상이 찾아올 것을 의미합니다. 충분한 휴식을 취하면 몸과 마음이 회복되어 더 큰 일을 해낼 수 있는 에너지를 얻게 됩니다.', omen: 'good', luckyNumbers: [2, 8, 17, 26, 35, 42], tags: ['보상', '회복'] },
      ]
    },
    {
      id: 'belly',
      name: '배 꿈',
      emoji: '🤰',
      summary: '배꿈은 풍요, 욕구, 내면의 상태를 상징합니다.',
      seoTitle: '배꿈 해몽 - 배(복부) 나오는 꿈 해석',
      seoDescription: '배가 아픈 꿈, 배가 부른 꿈, 배가 나오는 꿈 등 배꿈의 해몽을 확인하세요.',
      scenarios: [
        { id: 'full-belly', title: '배가 부른 꿈', interpretation: '배가 부른 꿈은 물질적, 정신적으로 풍요로운 시기가 올 것을 의미합니다. 충분히 만족스러운 생활을 하게 되며, 재물운도 좋아질 수 있습니다. 감사하는 마음으로 받아들이면 더 큰 복이 찾아옵니다.', omen: 'good', luckyNumbers: [1, 9, 18, 27, 36, 45], tags: ['풍요', '만족'] },
        { id: 'belly-pain', title: '배가 아픈 꿈', interpretation: '배가 아픈 꿈은 건강에 주의하라는 신호이거나, 마음속에 소화하지 못한 감정이 있음을 의미합니다. 스트레스를 관리하고, 실제로 건강에 이상이 느껴진다면 검진을 받아보세요. 억눌린 감정을 표현하면 마음이 편해질 수 있습니다.', omen: 'caution', luckyNumbers: [4, 11, 20, 29, 34, 40], tags: ['건강', '감정'] },
        { id: 'big-belly', title: '배가 불룩 나온 꿈', interpretation: '배가 불룩 나온 꿈은 새로운 프로젝트나 계획이 성장하고 있음을 의미합니다. 태몽일 수도 있으며, 사업이나 투자가 점점 커지는 좋은 징조입니다. 인내심을 가지고 키워나가면 큰 결실을 맺을 것입니다.', omen: 'good', luckyNumbers: [3, 10, 19, 28, 37, 43], tags: ['성장', '결실'] },
        { id: 'hungry-belly', title: '배가 고픈 꿈', interpretation: '배가 고픈 꿈은 현실에서 충족되지 않은 욕구가 있음을 반영합니다. 물질적인 것뿐 아니라 애정이나 인정에 대한 갈망일 수 있으니, 진정으로 원하는 것이 무엇인지 돌아보고 적극적으로 추구해보세요.', omen: 'caution', luckyNumbers: [5, 13, 22, 31, 38, 42], tags: ['욕구', '성찰'] },
      ]
    },
  ]
};
